import * as at from "../action-types";

const initialState = {
  nav: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case at.SET_BREADCRUMBS:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
